import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { MrDriveAvatar } from "@/components/MrDriveAvatar";
import { postAuthDestination } from "@/lib/onboarding-state";

export const Route = createFileRoute("/auth_/callback")({
  ssr: false,
  component: AuthCallbackPage,
});

function AuthCallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    async function resolveDestination() {
      // detectSessionInUrl обрабатывает возврат из Google автоматически,
      // ждём появления сессии.
      let userId: string | null = null;
      for (let i = 0; i < 20 && !userId; i++) {
        const { data } = await supabase.auth.getSession();
        userId = data.session?.user.id ?? null;
        if (!userId) await new Promise((r) => setTimeout(r, 250));
      }
      if (cancelled) return;
      if (!userId) {
        // Ссылка из письма открылась в другом браузере: почта уже подтверждена,
        // но сессии здесь нет — показываем вход с предзаполненным email.
        const params = new URLSearchParams(window.location.search);
        if (params.get("confirm") === "1") {
          const q = new URLSearchParams({ confirmed: "1", email: params.get("email") ?? "" });
          window.location.replace(`/auth?${q.toString()}`);
          return;
        }
        navigate({ to: "/auth", replace: true });
        return;
      }

      const dest = await postAuthDestination(userId);
      if (cancelled) return;
      window.location.replace(dest);
    }

    void resolveDestination();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
      <MrDriveAvatar variant="home" size={96} />
      <p className="text-sm text-td-muted">Завершаем вход…</p>
    </div>
  );
}
